<template>
    <div class="mult-export">
        <el-upload class="upload-demo" drag action="https://jsonplaceholder.typicode.com/posts/" multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击添加文件</em></div>
        </el-upload>
        <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 24px;margin-right: 30px;">
            <el-button type="primary" plain @click="saveData">保存</el-button>
            <el-button type="danger" plain @click="cancelData">取消</el-button>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        saveData() {

        },
        cancelData() {

        }
    }
}
</script>
<style scoped>
.upload-demo {
    display: flex;
    justify-content: center;
}
</style>